import { Flex } from 'foundations-components/components/Flex';
import { NavMarker } from 'react-rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MarketingHubPage = () => {
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "MARKETING_HUB_PAGE"
    }), /*#__PURE__*/_jsxs(Flex, {
      children: [/*#__PURE__*/_jsx("div", {
        children: "Starter"
      }), /*#__PURE__*/_jsx("div", {
        children: "Professional"
      }), /*#__PURE__*/_jsx("div", {
        children: "Enterprise"
      })]
    })]
  });
};